// extracted by mini-css-extract-plugin
module.exports = {"main-checkbox":"main-checkbox-2hG2fzL","color-label-error-state":"color-label-error-state-1RQGxlC","color-error-text":"color-error-text-3RLgxCn"};